// src/layout/Dashboard/Drawer/DrawerContent/Navigation/index.jsx

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { selectUserMenu } from '../../../../../Redux/slices/authSlice';
import NavGroup from './NavGroup';

// Recursively collect all unique icon names from menu tree
const collectIconNames = (items = []) => {
  const names = new Set();
  const walk = (list) => {
    list.forEach(item => {
      if (item.icon) names.add(item.icon);
      if (item.children?.length) walk(item.children);
    });
  };
  walk(items);
  return [...names];
};

// Map icon strings → components using a resolved iconMap
const buildMenuStructure = (items = [], iconMap = {}) =>
  items.map(item => ({
    id: `menu-${item.menuItemId}`,
    title: item.title,
    type: item.type,
    url: item.url,
    icon: item.icon ? (iconMap[item.icon] ?? null) : null,
    breadcrumbs: false,
    children: item.children ? buildMenuStructure(item.children, iconMap) : [],
  }));

export default function Navigation() {
  const rawMenu = useSelector(selectUserMenu);
  const [iconMap, setIconMap] = useState({});
  const [iconsLoaded, setIconsLoaded] = useState(false);

  useEffect(() => {
    if (!rawMenu?.length) return;

    const iconNames = collectIconNames(rawMenu);
    if (!iconNames.length) {
      setIconsLoaded(true);
      return;
    }

    // Dynamically import lucide-react and pick only needed icons
    import('lucide-react').then((lucide) => {
      const resolved = {};
      iconNames.forEach(name => {
        if (lucide[name]) resolved[name] = lucide[name];
      });
      setIconMap(resolved);
      setIconsLoaded(true);
    });
  }, [rawMenu]);

  if (!rawMenu?.length || !iconsLoaded) {
    return (
      <Box sx={{ pt: 2, px: 2 }}>
        <Typography
          variant="caption"
          color="rgba(255,255,255,0.4)"
          sx={{ fontFamily: 'inherit' }}
        >
          Loading menu...
        </Typography>
      </Box>
    );
  }

  const navGroups = rawMenu.map((item) => {
    const mappedItem = {
      id: `menu-${item.menuItemId}`,
      title: item.title,
      type: item.type,
      url: item.url,
      icon: item.icon ? (iconMap[item.icon] ?? null) : null,
      breadcrumbs: false,
      children: buildMenuStructure(item.children || [], iconMap),
    };

    switch (item.type) {
      case 'group':
        return <NavGroup key={mappedItem.id} item={mappedItem} />;
      default:
        return (
          <Typography key={mappedItem.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}